import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
import(/* webpackMode: "eager" */ "/app/src/views/events/detail.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/ResetSidebarItems.tsx")